import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Box, Page } from 'signoxe/components/layout';
import { Button, Popup, Icon, Switch } from 'signoxe/components/widgets';
import './styles.scss';

import { toggleDeviceId, updateDeviceGroup, updateContentFeed, fetchDeviceGroups, confirmationRequest, fetchAssets } from "signoxe/actions";
import { CONTENT_FEEDS_RESOURCE, DEVICE_GROUPS_RESOURCE, DEVICES_RESOURCE } from "signoxe/api/resources";
import { API_ROOT } from 'signoxe/constants/config';
import { getAuthTokenHeader } from "signoxe/actions/remote";
import { Link } from 'react-router-dom/es';


import { getDeviceGroup, getProfile } from 'signoxe/selectors';

import { callOnEnter } from 'signoxe/utils/eventHelpers';

import {
    ContentFeedView,
} from 'signoxe/components';

import { OrientationSelectWidget } from "signoxe/components/widgets/OrientationSelectWidget";

import URLAssetEditPage from 'signoxe/components/AssetModal/components/Url';
import AQIAirvedaPage from 'signoxe/components/AssetModal/components/Aqi_Airveda'
import FidsAssetPage from 'signoxe/components/AssetModal/components/Fids';
import AQIAssetPage from 'signoxe/components/AssetModal/components/Aqi';
import CalendarAssetPage from 'signoxe/components/AssetModal/components/Calendar';
import HtmlPage from 'signoxe/components/AssetModal/components/Html';
import YoutubePage from 'signoxe/components/AssetModal/components/Youtube';
import TwitterPage from 'signoxe/components/AssetModal/components/TwitterFeeds';
import Poll_App from 'signoxe/components/AssetModal/components/Poll_App';


class TemplatePage extends React.Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            addMode: false,
            currentKey: null
        }

        this.components = {
            'fids': FidsAssetPage,
            'aqi': AQIAssetPage,
            'aqi_airveda': AQIAirvedaPage,
            'youtube': YoutubePage,
            'twitter': TwitterPage,
            'calendar': CalendarAssetPage,
            'url': URLAssetEditPage,
            'html': HtmlPage,
            'poll': Poll_App,
        }
    }

    switchComponent(key) {
        this.setState({ currentKey: key })
    }

    renderComponent(currentKey) {
        const Component = this.components[currentKey];
        if (typeof (Component) === 'string') {
            return <div>Asset not yet supported.</div>
        }
        return <Component refresh={this.props.fetchAssets} history={this.props.history} disable={this.close.bind(this)} />
    }

    render() {
        const { visible, disable } = this.props;

        const { currentKey } = this.state

        return (
            <Page className="asset-content-popup">
                <Box className='modal-wrapper' direction="column" justifyContent="center">
                    <HtmlPage history={this.props.history} />
                </Box>
            </Page>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        // state,
        // profile: getProfile(state),
    }
}

export default connect(
    mapStateToProps,
    {
        fetchAssets
        // toggleDeviceId,
        // updateDeviceGroup,
        // updateContentFeed,
        // fetchDeviceGroups,
        // confirmationRequest
    })(TemplatePage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/TemplatePage/index.js